import './ApplyButton.scss'
import type { ReactNode } from 'react'
import type { PositionData } from '#src/pages/careers/careersPageData.js'

interface Props {
  data: PositionData
}

export function ApplyButton(props: Props): ReactNode {
  const { title, applyButton } = props.data
  return (
    <a className="position__apply-link" href={`${applyButton!.url}?subject=${title}`}>
      {applyButton!.text}
    </a>
  )
}
